import { useEffect, useRef, useContext, useState } from "react"
import PlannedServices4 from "../Forms/B/PlannedServices/PlannedServices4"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const PlannedServices4Container = ({ showToolBar, disabled, interview_id }) => {
  const {
    interview,
    handleSubmitGet,
    handleLoadPrev,
    loadCollection,
    plannedServices4Saved,
  } = useContext(GpraContext)
  const userCtx = useContext(UserContext)
  const [isGettingPlannedServices, setIsGettingPlannedServices] = useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingPlannedServices(true)
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      handleSubmitGet(endpoints.GET_PLANNED_SERVICES_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_4,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.PLANNED_SERVICES_4
          )
          handleLoadPrev(false)
          setIsGettingPlannedServices(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingPlannedServices(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_b_services_es_1: data?.form?.gpraBServicesEs1 ?? undefined,
      gpra_b_services_es_2: data?.form?.gpraBServicesEs2 ?? undefined,
      gpra_b_services_es_3: data?.form?.gpraBServicesEs3 ?? undefined,
      gpra_b_services_es_4: data?.form?.gpraBServicesEs4 ?? undefined,
      gpra_b_services_es_5: data?.form?.gpraBServicesEs5 ?? undefined,
      gpra_b_services_es_6: data?.form?.gpraBServicesEs6 ?? undefined,
      gpra_b_services_es_7: data?.form?.gpraBServicesEs7 ?? undefined,
      gpra_b_services_es_7a: data?.form?.gpraBServicesEs7a ?? undefined,
      gpra_b_services_p2p_1: plannedServices4Saved
        ? data?.form?.gpraBServicesP2p1
        : true,
      gpra_b_services_p2p_2: data?.form?.gpraBServicesP2p2 ?? undefined,
      gpra_b_services_p2p_3: data?.form?.gpraBServicesP2p3 ?? undefined,
      gpra_b_services_p2p_4: data?.form?.gpraBServicesP2p4 ?? undefined,
      gpra_b_services_p2p_5: data?.form?.gpraBServicesP2p5 ?? undefined,
      gpra_b_services_p2p_6: data?.form?.gpraBServicesP2p6 ?? undefined,
      gpra_b_services_p2p_7: data?.form?.gpraBServicesP2p7 ?? undefined,
      gpra_b_services_p2p_8: data?.form?.gpraBServicesP2p8 ?? undefined,
      gpra_b_services_p2p_8a: data?.form?.gpraBServicesP2p8a ?? undefined,
      gpra_b_services_p2p_9: data?.form?.gpraBServicesP2p9 ?? undefined,
      gpra_b_services_p2p_9a: data?.form?.gpraBServicesP2p9a ?? undefined,
      gpra_b_services_id: data?.form?.gpraBServicesId ?? 0,
      additional: data?.additional,
    }
  }

  if (isGettingPlannedServices) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingPlannedServices && (
        <PlannedServices4 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default PlannedServices4Container
